import { IFamocoTranslations } from '..';

const famoco: IFamocoTranslations = {
  famoco_settings: 'Famoco Settings',
  api_token: 'API Token',
  api_token_placeholder: 'Enter API token from Famoco web UI',
  has_api_token: 'API token',
  token_not_set: 'Not set',
  token_is_set: 'Configured',
  org_id: 'Organisation ID',
  org_id_placeholder: 'Enter organisation ID (e.g. 1487)',
  base_url: 'Base URL',
  base_url_placeholder: 'https://my.famoco.com',
  save_config: 'Save configuration',
  sync_fleets: 'Sync fleets',
  fleets: 'Fleets',
  fleet_name: 'Fleet name',
  famoco_id: 'Famoco ID',
  not_configured: 'Famoco is not configured. Enter your API credentials to get started.',
  no_fleets: 'No fleets synced yet. Click "Sync fleets" after saving your configuration.',
  config_saved: 'Configuration saved.',
  fleets_synced: 'Fleets synced successfully.',
  config_error: 'Failed to save configuration.',
  sync_error: 'Failed to sync fleets.',
  updated_at: 'Last updated',
  sync_devices: 'Sync devices',
  sync_devices_error: 'Failed to sync devices.',
  famoco_devices: 'Famoco devices',
  in_fleet: 'In fleet',
  in_stock: 'In stock',
  licenses: 'Licenses',
  api_token_placeholder_update: 'Enter a new token to replace the existing one',
  validate_token: 'Validate token',
  validating: 'Validating…',
  token_valid: 'Token is valid',
  validation_error: 'Token validation failed.',
  select_org: 'Select organisation',
  org: 'Organisation',
  save_and_sync: 'Save & Sync',
  saving_and_syncing: 'Saving & syncing…',
  save_and_sync_success: 'Configuration saved and synced.',
  sync_all: 'Sync Famoco state',
  sync_all_success: 'Famoco state synced.',
  sync_all_error: 'Sync failed.',
  update_token: 'Update token',
  cancel: 'Cancel'
};

export default famoco;
